import React from "react";
import { useParams } from "react-router-dom";
import Card from "components/card";
import AssignedAssetsForm from "./components/AssignedAssetsForm";

const ViewAssignedAssets = () => {
    const { assetId } = useParams();

    return (
        <div className="dark-mode-card p-3 border-2 dark:border-gray-700 rounded-2xl">
            <AssignedAssetsForm
                recordId={assetId}
                mode="view"
            />
        </div>
    );
};

export default ViewAssignedAssets;